import { MutationTypes, store } from '@/store'
import { createRouter, createWebHistory } from 'vue-router'
const templates = () => import('../views/Template/index.vue')
const editor = () => import('../views/Editor/index.vue')
const preview = () => import('../views/Editor/preview.vue')
const cover = () => import('../views/Editor/cover.vue')
const dashboard = () => import('../views/Dashboard/index.vue')
const space = () => import('../views/Space/index.vue')
const home = () => import('../views/Home/index.vue')
const material = () => import('../views/Material/index.vue')
const material_mk = () => import('../views/Material/material.vue')
const collect = () => import('../views/Collect/index.vue')
const order = () => import('../views/Order/index.vue')
const set = () => import('../views/Set/index.vue')
const navigation = () => import('../views/Navigation/index.vue')
const template_detail = () => import('../views/Template/detail.vue')
const login = () => import('../views/Login/index.vue')
const error = () => import('../views/components/layout/404.vue')
const resume = () => import('../views/Resume/home/index.vue')
const subject = () => import('../views/Dashboard/subject.vue')
const edit_share = () => import('../views/Editor/Share/index.vue')
const edit_invite = () => import('../views/Editor/Invite/index.vue')
import Layout from '../views/components/layout/Index.vue'

const routes = [
  {
    path: '/',
    name: 'home',
    component: dashboard
  },
  {
    path: '/login',
    name: 'login',
    component: login,
 
  },
  {
    path: '/templates/:id',
    component: Layout,
    redirect: '/templates',
    children: [
      {
        path: '',
        component: templates,
        name: 'templates_index',
        meta: {title: '首页', icon: 'templates', noCache: true, affix: true},
      },
      {
        path: '/template/:templateId',
        name: 'templateId',
        component: template_detail,
      }
    ]
  },
  {
    path: '/subject/:subjectId',
    name: 'subjectId',
    component: subject
  },
  {
    path: '/dashboard',
    name: 'dashboard',
    component: home,
  },
  {
    path: '/templates',
    name: 'templates',
    redirect: '/templates/FL0',
  },
  {
    path: '/editor',
    name: 'editor',
    meta: {
      allowBack:false,
      requireAuth: true, // 添加该字段，表示进入这个路由是需要登录的
    },
    component: editor,
  },
  {
    path: '/editor/share/:contentId',
    name: 'shareId',
    meta: {
      allowBack:false,
      requireAuth: true, // 添加该字段，表示进入这个路由是需要登录的
    },
    component: edit_share,
  },
  {
    path: '/editor/invite/:contentId',
    name: 'inviteId',
    meta: {
      allowBack:false,
      requireAuth: true, // 添加该字段，表示进入这个路由是需要登录的
    },
    component: edit_invite,
  },
  {
    path: '/preview',
    name: 'preview',
    component: preview
  },
  {
    path: '/cover',
    name: 'cover',
    component: cover
  },
  {
    path: '/space',
    name: 'space',
    meta: {
      allowBack:false,
      requireAuth: true, // 添加该字段，表示进入这个路由是需要登录的
    },
    component: space
  },
  {
    path: '/collect',
    name: 'collect',
    component: collect
  },
  {
    path: '/set',
    name: 'set',
    meta: {
      requireAuth: true, // 添加该字段，表示进入这个路由是需要登录的
    },
    component: set
  },
  {
    path: '/order',
    name: 'order',
    meta: {
      requireAuth: true, // 添加该字段，表示进入这个路由是需要登录的
    },
    component: order
  },
  {
    path: '/navigation',
    name: 'navigation',
    component: navigation,
    meta: {
      requireAuth: true, // 添加该字段，表示进入这个路由是需要登录的
    },
  },
  {
    path: '/material',
    name: 'material',
    component: Layout,
    children: [
      {
        path: '',
        component: material,
        name: 'material_index',
        meta: {title: '首页', icon: 'material', noCache: true, affix: true},
      },
      {
        path: '/material/mk/:templateId',
        name: 'material_mks',
        component: material_mk
      },
      {
        path: '/material/mk',
        name: 'material_mk',
        redirect: '/material/mk/17',
      },
      {
        path: '/material/bj/:templateId',
        name: 'material_bjs',
        component: material_mk
      },
      {
        path: '/material/bj',
        name: 'material_bj',
        redirect: '/material/bj/19',
      },
      {
        path: '/material/music/:templateId',
        name: 'material_musics',
        component: material_mk
      },
      {
        path: '/material/music',
        name: 'material_music',
        redirect: '/material/music/217',
      },
      {
        path: '/material/fonts/:templateId',
        name: 'material_fonts',
        component: material_mk
      },
      {
        path: '/material/fonts',
        name: 'material_font',
        redirect: '/material/fonts/25',
      },
    ]
  },
  {
    path: '/resume',
    name: 'resume',
    component: resume,
    meta: {title: '首页', icon: 'resume', noCache: true, affix: true},
  },
  {
    path: '/404',
    name: '404',
    component: error
  },
  { path: '/:pathMatch(.*)*', redirect: '/404' }
]
// router/index.js
const writer = (to: any) => {
  // 首先找到head里的meta
  const deleArr: any = []
  document.head.childNodes.forEach(item => {
    switch (item.nextSibling?.nodeName) {
      case 'META':
        deleArr.push(item.nextSibling)
        break
    
      case 'TITLE':
        document.title = to.meta.title || to.name
        break
      
      default:
        break
    }
  })
 
  // 删除原来的meta
  deleArr.forEach((item: any) => {
    document.head.removeChild(item)
  })
 
  // 添加想要的meta（全局）
  const metas = document.createElement("META")
  const creatArr = [
    { charset: "utf-8" },
    { "http-equiv": "X-UA-Compatible", content: "IE=edge,chrome=1" },
    // 视图缩放
    { name: "viewport", content: "width=1240, user-scalable=no" }
  ]
 
  // 将单个路由设定的meta加到creatArr数组中
  // 局部meta和全局meta重复时，局部meta替换全局meta
  const tmpArr = to.meta.data ? to.meta.data.concat() : []
 
  if (tmpArr.length > 0) {
    to.meta.data.forEach((item:any, index:any) => {
      creatArr.forEach((ele, ind) => {
        if (Object.keys(item)[0] === Object.keys(ele)[0]) {
          creatArr[ind] = JSON.parse(JSON.stringify(item))
          tmpArr.splice(index, 1)
        }
      })
    })
  }
 
  // 生成合并后的数组
  const eleArr = creatArr.concat(tmpArr)
 
  // 将设定的值写入文档片段
  const creatFrag = document.createDocumentFragment()
  if (creatFrag !== null) {
    eleArr.forEach(ele => {
      creatFrag.append(metas.cloneNode())
      Object.entries(ele).forEach(item => {
        creatFrag.lastElementChild?.setAttribute(item[0], item[1])
      })
    })
  }

 
  // 将文档片段写入head
  document.head.prepend(creatFrag)
}
const router = createRouter({
  history: createWebHistory(),
  routes: routes,
  scrollBehavior: () => {
    history.pushState(null, '', document.URL)
  }
})

router.beforeEach((to, from, next) => {
  // writer(to)
  next()
})
export default router